/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_View_JaarInputs */

const nl_planning_view_jaar = /** @type {(inputs: Planning_View_JaarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarplanning`)
};

/**

* @param {Planning_View_JaarInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_view_jaar = /** @type {((inputs?: Planning_View_JaarInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_View_JaarInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_view_jaar(inputs)
});
export { planning_view_jaar as "planning.view_jaar" }